import {GEO_SERVER_BASE_URL} from "./constant";

export function showLoading(_, evt) {
    document.getElementById("tail-loading").style.display = 'block'
}

export function hideLoading(_, evt) {
    document.getElementById("tail-loading").style.display = 'none'
}

export function generateUrlGeoserverVector(workspace, layerName, style='') {
    return GEO_SERVER_BASE_URL +
        '?REQUEST=GetTile' +
        '&SERVICE=WMTS' +
        '&VERSION=1.0.0' +
        '&LAYER=' + workspace + ":" + layerName +
        '&STYLE=' + style +
        '&TILEMATRIX=EPSG:900913:{z}' +
        '&TILEMATRIXSET=EPSG:900913' +
        '&FORMAT=application/vnd.mapbox-vector-tile' +
        '&TILECOL={x}' +
        '&TILEROW={y}'
}

